/**
 * The value of a filter option that represents an 'All' selection.
 */
export const allFilterOptionValue = 'all';
